import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher';
import assign from 'object-assign';

const ResourceStore = assign({}, EventEmitter.prototype, {

  _state: undefined,
  isLoading: false,

  _updateState(state) {
    this._state = state;
    Dispatcher.emit(Dispatcher.RESOURCE_STORE_CHANGE);
  },

  get(id) {
    this._load();
    return this._state ? this._state[id] : undefined;
  },

  getAll() {
    this._load();
    return this._state || undefined;
  },

  _filterResponse(data) {

    // Widths coming back in response, can use this if we don't feel like hard coding
    let width = 60

    data.ancillaries.map(item => {
      item.coverURL = data.coverURL
      .replace(":isbn" , item.isbn)
      .replace(":width" , width)

      return item;
    })
    return data.ancillaries;
  },

  _load(update) {
    if (!this.isLoading && (update || this._state === undefined)){
      this.isLoading = true;
      Jigsaw.getAncillariesSummary(function(response){
        if (response.isSuccess()){
          this._updateState(this._filterResponse(response.data));
        }else{
          this._updateState([]);
        }
        this.isLoading = false;
      }.bind(this));
    }
  },

  init() {
    Dispatcher.on(Dispatcher.USER_LICENSE_UPDATED, ()=>{
      this._updateState(undefined);
    });
  }

});

ResourceStore.init();
export default ResourceStore;



/** WEBPACK FOOTER **
 ** ./src/js/stores/resource-store.js
 **/